import { db } from "common/config/Firebase";

const notesCollection = db.collection("notes");

const findNotesUseCase = (callback) => {
  // Notas más recientes arriba
  return notesCollection
    .orderBy("createdAt", "desc")
    .onSnapshot(callback);
};

export default findNotesUseCase;